import React, {useContext, useState} from 'react';
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import {AdtaDeviceOverviewContext} from "../context/AdtaDeviceOverviewContext";
import Select, {SelectOption} from "@amzn/meridian/select";
import escapeRegExp from "lodash/escapeRegExp"

const DeleteAdtaSorterTestPackageModal = (props) => {

    const {formatMessage} = props.intl;
    const {mac} = props;
    const {open, setOpen} = props;
    const {viewModel, dispatch} = useContext(AdtaDeviceOverviewContext);
    const [scannables, setScannables] = useState("")
    const [searchQuery, setSearchQuery] = useState("")

    const onCloseModal = () => {
        setOpen(false);
        resetInputState();
    }

    const testConfigList = viewModel.sorterTestPackageConfig[mac].map(({scannables}) => {
        return Array.isArray(scannables) ? scannables.join(';') : scannables
    });
    const searchRegExp = new RegExp(escapeRegExp(searchQuery), "i")
    const matchedOptions = testConfigList.filter(
        option => !searchQuery || searchRegExp.test(option)
    )

    const onClickConfirm = () => {
        deleteData();
        setOpen(false)
        resetInputState();
    }

    function resetInputState() {
        setScannables("");
    }

    const deleteData = () => {
        dispatch({
            type: 'DELETE_DEVICE_TEST_PACKAGE_DATA',
            data: {dispatcher: dispatch, mac: mac, scannables: scannables}
        })
    }

    return (
        <Row>
            <Modal
                title={formatMessage({id: "config.deletetest"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                    <FormattedMessage id="modal.sortzonedelete"
                                      defaultMessage="Please select the scannable you would like to remove."/>
                </Text>
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Select
                        value={scannables}
                        onChange={setScannables}
                        searchQuery={searchQuery}
                        onSearch={setSearchQuery}
                        placeholder="Select test package to be deleted."
                        width={300}>
                        {matchedOptions.map((scannable) =>
                            <SelectOption key={scannable} value={scannable} label={scannable}/>
                        )}
                        {!matchedOptions.length ? (
                            <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                {testConfigList ? <Text alignment="center"> No matching test packages </Text>
                                    : <Text alignment="center"> No test packages available </Text>}
                            </Column>) : null}
                    </Select>
                </Column>
                <ModalFooter>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="medium" onClick={onCloseModal}>
                            <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                        </Button>
                        <Button type="primary" size="medium" onClick={onClickConfirm}>
                            <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                        </Button>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(DeleteAdtaSorterTestPackageModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/modal/DeleteAdtaSorterTestPackageModal.js